import { render, staticRenderFns } from "./ajla.vue?vue&type=template&id=0471ba9e&scoped=true&"
import script from "./ajla.vue?vue&type=script&lang=js&"
export * from "./ajla.vue?vue&type=script&lang=js&"
import style0 from "./ajla.vue?vue&type=style&index=0&id=0471ba9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0471ba9e",
  null
  
)

export default component.exports